import { useModalStore } from "@/stores/use-modal-store";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { EmotionScore } from "@/api/studio/insights/types/emotion.type";
import { MemoryEmotionIndicator } from "@/components/ui/indicator";
import { useEffect } from "react";

/* Emotion score data - using shared constants */
const emotionScores: EmotionScore[] = [3, 2, 1, 0, -1, -2, -3];

/*
 * AOIEmotionInfoModal component
 *
 * This modal displays information about the AOI emotion scores and their meanings.
 */
export const AOIEmotionInfoModal = () => {
  /* Hooks */
  const { close, setConfig } = useModalStore((state) => state.modalActions);
  useEffect(() => {
    setConfig({
      className: "w-full max-w-[400px]",
    });
  }, [emotionScores]);

  /* Render */
  return (
    <div className="flex flex-col gap-4">
      {/* Header */}
      <div className="flex items-center justify-center relative">
        <h2 className="text-xl font-semibold">AOI elements</h2>
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0 hover:opacity-70 transition-opacity" />
      </div>

      {/* Description */}
      <p className="text-center text-base-content">Each element can have a positive or a negative emotional reaction:</p>

      {/* Emotion Scores List */}
      <div className="flex flex-col">
        {emotionScores.map((score) => (
          <div key={score} className="flex items-center py-2.5 px-4 bg-base-200 first:rounded-t-lg last:rounded-b-lg border-b-2 border-base-100 last:border-b-0">
            <div className="flex items-center px-1.5">
              <MemoryEmotionIndicator score={score} type="emotion" size="small" textSize="sm" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
